import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";





const FormularioForm=({ onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{



	return (
        <Container>

			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.nombreFormulario}>            
                              <label  >{strings?strings["quizTitle"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["quizTitle"]:""} 
                                    name="nombreFormulario"
                                    onChange={onChange}
                                    value={datos.nombreFormulario}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["quizSynopsis"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["quizSynopsis"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/examens">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
            
        </Container>
	);
};



export default FormularioForm;